import WebCourseRecommend from '../Web/PageComponents/CourseRecommend';
import MobileCourseRecommend from '../Mobile/PageComponents/CourseRecommend';
import { Display } from '@/components/Display/Display';
const CourseRecommend = (props) => {
    const { side = 'web', ...otherProps } = props;
    return (
        <>
            <Display show={side === 'web'}>
                <WebCourseRecommend {...otherProps}></WebCourseRecommend>
            </Display>
            <Display show={side === 'mobile'}>
                <MobileCourseRecommend {...otherProps}></MobileCourseRecommend>
            </Display>
        </>
    );
};

export default CourseRecommend;
